import React from "react";
import AntdCollapse, {CollapseProps} from "antd/lib/collapse";
import { withError} from '@fishx/tracker';

const Panel = AntdCollapse.Panel;
interface FCProps extends React.FC<CollapseProps> {
  Panel: typeof Panel;
} 
const Collapse: FCProps = (props) => {
  return <AntdCollapse {...props} />;
}
Collapse.Panel = Panel;
Collapse.displayName = 'Collapse';
export default withError(Collapse);


// WEBPACK FOOTER //
// ./src/components/collapse/index.tsx